import React from 'react';
import Moment from 'moment';
import 'moment/locale/es';
import { useSelector } from 'react-redux';
import '../paquete-checkout-detalle.css';
import { useTranslation } from 'react-i18next';

const Tramo = (props) => {
  const { t } = useTranslation('translations');
  const lang = t('requestForm.monthLang');

  return (
    <ul className='mt-5'>
      <li className='text-lg font-bold text-gray-900'>
        <span className='resaltado origen'>
          {props.tramo.aeropuertoOrigen || props.tramo.destinationCode}
        </span>
        {' - '}
        <span className='resaltado destino'>
          {props.tramo.aeropuertoLlegada || props.tramo.originCode}
        </span>
      </li>
      <div className='tramo-destacado'>
        {(props.escalas === 0)
          ? t('checkout.direct')
          : (props.escalas > 1)
            ? `${props.escalas} ${t('checkout.scales-flight')}`
            : `${props.escalas} ${t('checkout.scale-flight')}`}
      </div>
      <li>
        <div className='col-md-4 col-sm-4 col-xs-4'>
          <div className='tramo-data'>
            <div className='noticed-text mr-2'>
              {t('packages.depart')}
            </div>
            <ul className='list-unstyled flex'>
              <li className='tramo-data mr-2'>
                { Moment(props.tramo.departureDate).locale(lang).format('dddd DD MMMM')}
              </li>
              <li className='tramo-data mr-2'>
                {`${Moment(props.tramo.departureDate).locale(lang).format('h:mm a')} ` }
              </li>
            </ul>
          </div>
        </div>
        <div className='col-md-5 col-sm-5 col-xs-5'>
          <div className='tramo-data'>
            <div className='noticed-text mr-3'>
              {t('packages.arrive')}
            </div>
            <ul className='list-unstyled flex'>
              <li className='tramo-data mr-3'>
                {Moment(props.tramo.arrivalDate).locale(lang).format('dddd DD MMMM ')}
              </li>
              <li className='tramo-data mr-3'>
                {`${Moment(props.tramo.arrivalDate).locale(lang).format('h:mm a')} ` }
              </li>
            </ul>
          </div>
        </div>
      </li>
      <div className='clearfix' />
    </ul>
  );
};
export default Tramo;
